import { useState } from 'react';
import { VERMIWASH_1, VERMIWASH_2 } from '../../data/parasHomeData';
import { CheckCircleIcon } from './HomeIcons';

export default function VermiwashSection() {
  const [washImg, setWashImg] = useState(0);
  const washImages = [VERMIWASH_1, VERMIWASH_2];

  return (
    <section className="section" id="vermiwash" aria-label="Vermiwash product" style={{ background: 'var(--white)' }}>
      <div className="section-inner">
        <div className="product-grid">
          <div className="product-info-col">
            <div className="product-badge-row">
              <span className="badge gold">Liquid Fertilizer</span>
              <span className="badge">100% Organic</span>
              <span className="badge">With Growth Hormones</span>
              <span className="badge">For All Crops</span>
            </div>
            <h2 className="product-name">Premium Organic<br />Vermiwash</h2>
            <p className="product-tagline">
              A powerful liquid fertilizer extracted from vermicompost leachate. Enriched with Iron, Potassium, Nitrogen, Phosphorus, plus natural growth hormones like auxins and gibberellins - promoting strong roots and pest-resistant plants.
            </p>
            <ul className="features-list">
              <li><span className="feat-icon"><CheckCircleIcon className="ui-icon feature-check-icon" /></span>Boosts root and plant growth with bioavailable nutrients and natural growth hormones</li>
              <li><span className="feat-icon"><CheckCircleIcon className="ui-icon feature-check-icon" /></span>Improves soil health - enhances aeration, water retention, and microbial activity</li>
              <li><span className="feat-icon"><CheckCircleIcon className="ui-icon feature-check-icon" /></span>Builds drought resistance by strengthening soil's water-holding capacity</li>
              <li><span className="feat-icon"><CheckCircleIcon className="ui-icon feature-check-icon" /></span>Especially effective for mango, fruit, vegetable crops and all agricultural uses</li>
              <li><span className="feat-icon"><CheckCircleIcon className="ui-icon feature-check-icon" /></span>Use as foliar spray, soil drench, seed treatment, or compost booster</li>
            </ul>
            <div className="product-cta-row">
              <a href="/vermiwash" className="btn-primary">View Full Details</a>
            </div>
          </div>
          <div className="product-image-col">
            <div className="product-image-frame" style={{ background: 'var(--green-faint)' }}>
              <img src={washImages[washImg]} alt="Paras Premium Organic Vermiwash" />
            </div>
            <div className="img-thumb-row">
              {washImages.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`Vermiwash view ${i + 1}`}
                  className={`img-thumb${washImg === i ? ' active' : ''}`}
                  onClick={() => setWashImg(i)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
